import React from 'react';
import styled from 'styled-components';

import { convertThumbnailToPictureProps } from '@tager/web-modules';

import Link from '@/components/Link';
import Picture from '@/components/Picture';
import { CategoryRelation, ProductsCategoryType } from '@/typings/model';

type Props = {
  data: CategoryRelation[] | ProductsCategoryType[];
  type?: string;
};

function Relations({ data, type }: Props) {
  return (
    <Component>
      {data.length > 0
        ? data.map((item) => (
            <Link key={item.id} to={`/catalog${item.urlPath}`}>
              <RelationsCard>
                {type === 'searchPage' ? (
                  <Picture src={(item as ProductsCategoryType).icon} />
                ) : (
                  <Picture
                    {...convertThumbnailToPictureProps(
                      (item as CategoryRelation).image
                    )}
                  />
                )}
                <Description>{item.name}</Description>
              </RelationsCard>
            </Link>
          ))
        : null}
    </Component>
  );
}

export default Relations;

const Component = styled.div`
  margin: 6px -15px 0;
  position: relative;
  padding: 12px 15px;
  display: grid;
  grid-auto-flow: column;
  align-items: start;
  justify-content: start;

  gap: 10px;
  overflow-x: auto;
  background: rgb(245, 245, 245);
`;

const RelationsCard = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 140px;
  height: 100%;
  picture {
    width: 100%;
    height: 100%;
  }

  img {
    height: 50px;
    width: 120px;
    display: block;
    position: relative;
    max-height: 80px;
    overflow: hidden;
    object-fit: contain;
    margin: 0 auto;
  }

  & > div:first-child {
    margin-bottom: 12.5px;
  }
`;
const Description = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
`;
